import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "../header.css";
import { DomainContext } from "../../../../libs/context";

const LogoBlock = (props) => {
  const domainDetails = useContext(DomainContext)
  return (
    <div className="flexMinWidthRow">
      <div className="flexInline">
        <div className="logoCnt">
        {!props.nolink ? (
          <Link to="/dashboard">
            {domainDetails?.domain?.logo__url && <img src={domainDetails?.domain?.logo__url} alt="logo" />}
          </Link>
        ) : (
          domainDetails?.domain?.logo__url && <img src={domainDetails?.domain?.logo__url} alt="logo" />
        )}
        </div>
      </div>
    </div>
  );
};

export default LogoBlock;
